import { Component } from '@angular/core';
import { Platform, NavController, AlertController, PopoverController, ModalController } from 'ionic-angular';
import { DragulaService } from 'ng2-dragula';

import { PopoverQueuePage } from '../popover-queue/popover-queue';
import { PopoverSymptomPage } from '../popover-symptom/popover-symptom';
import { PopoverDxPage } from '../popover-dx/popover-dx';
import { DispensaryPage } from '../dispensary/dispensary';
import { HistoryPage } from '../history/history';

import { DataProvider } from '../../providers/data/data';
import { ConstantsProvider } from '../../providers/constants/constants';
import { ConsultationDataProvider } from '../../providers/consultation-data/consultation-data';
// import { ConsultationDisplayProvider } from '../../providers/consultation-display/consultation-display';

import { CloudDataProvider } from '../../providers/cloud-data/cloud-data';
import { LoadingPage } from '../loading/loading';

import { Subscription } from 'rxjs';

import * as $ from 'jquery';
import { Console } from '@angular/core/src/console';

@Component({

  selector: 'page-consultation',
  templateUrl: 'consultation.html'
})

export class ConsultationPage {

  private lastSearchStr = '';
  private activeSymptomGrps = [];
  private activeSymptoms = [];
  private actives: any = [];
  private subs: Subscription = new Subscription();

  public list = ['123', '456'];
  /** ----- Constructor ----- **/

  constructor(
    private data: DataProvider,
    private constants: ConstantsProvider,
    private consultationData: ConsultationDataProvider,
    // private consultationDisplay: ConsultationDisplayProvider,
    private platform: Platform,
    private navCtrl: NavController,
    private alertCtrl: AlertController,
    private popoverCtrl: PopoverController,
    private dragService: DragulaService,
    private cloudData: CloudDataProvider,
    private modalCtrl: ModalController,
  ) {

    // mark edit currently active
    // consultationData.editActive = true;

    // drag and drop setup
    if (this.dragService.find('consultation-bag') == null) {
      var temp = this.dragService.createGroup('consultation-bag', {

        moves: (el, source, handle, sibling) => source.getAttribute('id').indexOf('consultation-bag') > -1,
        accepts: (el, target, source, sibling) => target.getAttribute('id') == 'consultation-detection',
        copy: (el, source) => source.getAttribute('id').indexOf('consultation-bag') > -1,
        copySortSource: false,
        revertOnSpill: true,
      });

      this.dragService.drag('consultation-bag')
        .subscribe(value => {
          // console.log("Draging ")
        });

      this.subs.add(this.dragService.drop('consultation-bag')
        .subscribe(({ name, el, target, source, sibling }) => {
          if (target.id == 'consultation-detection') {
            // console.log(el)
            this.onItemChoiceClicked(el.id.split('-')[2], el.id.split('-')[3]);
          }
          el.parentNode.removeChild(el);
        })
      );

      this.subs.add(
        this.dragService.out("consultation-bag").subscribe(val => {
          // console.log("outing")
          $('.cons-symptom-board-container').each(function (i, obj) {

            $(obj).css('opacity', '1.0');
          });
        })
      )

      this.subs.add(this.dragService.over("consultation-bag").subscribe(({ name, el, container, source }) => {
        // console.log("overing")
        $('.cons-symptom-board-container').each(function (i, obj) {
          $(obj).css('opacity', '0.2');
        });
      }));

      // this.dragService.drop().subscribe(val => {
      //   console.log(val)
      //   if (val[2].id == 'consultation-detection') {
      //     console.log(val)
      //     // this.onItemChoiceClicked( val[ 1 ].id.split( '-' )[ 2 ] );
      //   }
      //   val[1].parentNode.removeChild(val[1]);
      // });

      // this.dragService.over("consultation-detection").subscribe(val => {
      //   console.log(123)
      //   $('.cons-symptom-board-container').each(function (i, obj) {

      //     $(obj).css('opacity', '0.2');
      //   });
      // });

      // this.dragService.out("consultation-detection").subscribe(val => {
      //   console.log(555)
      //   $('.cons-symptom-board-container').each(function (i, obj) {

      //     $(obj).css('opacity', '1.0');
      //   });
      // });

    }

  }

  ionViewWillEnter() {

    this.data.currentStep = 0;
    let val = this.platform.height();
    $('#consultation-detection').css('height', (val - 70 - 65 - 150 - 40 - 50 - 50 - 100) + 'px');
    let testVal = $('#consultation-detection').height() + 50 + 50 + 150;
    //$('.cons-bag-scroll').css('height', testVal + 'px');

    // reset search result
    this.lastSearchStr = '';
    this.onSearchClicked(this.lastSearchStr);

  }


  /** ----- Internal Methods ----- **/

  modifyRemark(inStr) {

    // if the requested string is too long
    if (inStr.length > 20) {
      return inStr.substring(0, 20) + '...';
    }

    // default return original string
    return inStr;

  }


  checkActive(inGrpIdx, inIdx) {

    return (this.consultationData.chosenSymptoms.indexOf(this.activeSymptoms[inGrpIdx][inIdx]['id']) > -1) ? true : false;

  }


  /** ----- UI Callbacks ----- **/

  onBackClicked() {

    let backConfirm = this.alertCtrl.create({
      title: '返回',
      subTitle: '已輸入的資料將不會被儲存，確認要返回嗎？',
      buttons: [
        {
          text: '取消',
          role: 'cancel'
        },
        {
          text: '確認',
          handler: () => {
            this.consultationData.clearAll();
            // mark edit currently inactive

            // if NOT under 'edit-mode'
            // if ( !this.consultationData.editMode )
            // {
            // if navigation stacks more than 3 views
            if (this.navCtrl.getViews().length > 3) {
              // remove all unnecessary page(s) before pop
              this.navCtrl.remove(2, this.navCtrl.getViews().length - 3).then(res => {

                this.navCtrl.pop();
              });
            }
            else {
              this.navCtrl.pop();
            }
            // }
            // else
            // {
            //    this.navCtrl.pop();
            // }

            // clear all status
            this.consultationData.clearAll();
          }
        }
      ],
      enableBackdropDismiss: false
    });
    backConfirm.present();

  }


  onNavBtnClicked(inIdx) {

    this.data.activeTab = inIdx;
    if (inIdx == 1) {
      // push to History and remove this page
      this.navCtrl.push(HistoryPage, { clearData : false }, { animate: false });
      this.navCtrl.remove(this.navCtrl.getViews().length - 1, 1);
    }

  }


  onQueueBtnClicked(inEvent) {

    let tempIdx = this.data.activeTab;
    this.data.activeTab = 0;
    let dxPopover = this.popoverCtrl.create(PopoverQueuePage, {}, { cssClass: 'queue-popover' });
    dxPopover.present({
      ev: inEvent
    });
    dxPopover.onWillDismiss(res => {
      this.data.activeTab = tempIdx;
    });

  }


  onSearchClicked(inStr) {

    // clear search result
    this.activeSymptomGrps = [];
    this.activeSymptoms = [];
    this.actives = [];


    // if searching with empty string
    if (this.lastSearchStr == null || this.lastSearchStr == '') {

      // if requested symptomData is in this category
      for (let i = 0; i < this.data.symptoms.length; i++) {
        let idx = this.activeSymptomGrps.indexOf(this.data.symptoms[i]['name_zh']);
        if (idx > -1) {
          this.activeSymptoms[idx].push(this.data.symptoms[i]);
        }
        else {
          this.activeSymptomGrps.push(this.data.symptoms[i]['name_zh']);
          this.activeSymptoms.push([this.data.symptoms[i]]);
        }
      }

    }
    else {

      // get all related item(s)
      let symptomData = $.grep(this.data.symptoms, function (element, sindex) {

        return (element['item_name_zh'].toLowerCase().indexOf(inStr.toLowerCase()) > -1);
      });


      // loop category
      for (let i = 0; i < symptomData.length; i++) {

        let idx = this.activeSymptomGrps.indexOf(symptomData[i]['name_zh']);
        if (idx > -1) {
          this.activeSymptoms[idx].push(symptomData[i]);
        }
        else {
          this.activeSymptomGrps.push(symptomData[i]['name_zh']);
          this.activeSymptoms.push([symptomData[i]]);
        }
        this.actives[i] = true;

      }

    }

  }
  onSearchInput (e) {
    this.onSearchClicked(e.target.value)
  }


  onSearchClearClicked() {

    this.lastSearchStr = '';
    this.onSearchClicked(this.lastSearchStr);

  }


  onDxClicked(inEvent) {

    let dxPopover = this.popoverCtrl.create(PopoverDxPage, { 'init': this.consultationData.dxIdx, 'callback': this.dxHandler }, { cssClass: 'dx-popover' });
    dxPopover.present({
      ev: inEvent
    });

  }


  dxHandler = (inIdx) => {
    return new Promise<void>(resolve => {
      this.consultationData.dxIdx = inIdx;
      resolve();
    });
  }


  onItemClicked(inIdx) {

    // mark category open state
    this.actives[inIdx] = !this.actives[inIdx];

  }


  onItemChoiceClicked(inGrpIdx, inIdx) {
    console.log("activer symptioms")
    console.log(this.activeSymptoms)
    if (this.checkActive(inGrpIdx, inIdx)) {
      let tempIdx = this.consultationData.chosenSymptoms.indexOf(this.activeSymptoms[inGrpIdx][inIdx]['id']);
      this.onSymptomRemoveClicked(tempIdx);
    }
    else {
      console.log('chosen: ' + this.activeSymptoms[inGrpIdx][inIdx]['id']);
      this.consultationData.chosenSymptoms.push(this.activeSymptoms[inGrpIdx][inIdx]['id']);
      this.consultationData.chosenSymptomsRemark.push('');
    }
    if (this.lastSearchStr != null && this.lastSearchStr != '') {
      this.onSearchClearClicked();
    }
  }


  onSymptomItemClicked(inEvent, inIdx) {

    // show conflicts dropdown
    let popover = this.popoverCtrl.create(PopoverSymptomPage, { 'idx': inIdx, 'value': this.consultationData.chosenSymptomsRemark[inIdx], 'callback': this.symptomPopupHandler }, { cssClass: 'symptom-popover' });
    popover.present({
      ev: inEvent
    });

  }


  symptomPopupHandler = (inIdx, inItemIdx, inStr) => {
    return new Promise<void>(resolve => {
      this.consultationData.chosenSymptomsRemark[inIdx] = inStr;
      resolve();
    });
  }


  onSymptomRemoveClicked(inIdx) {

    // prompt for confirmation
    let symptomRemoveConfirm = this.alertCtrl.create({
      title: '刪除',
      subTitle: '確認要刪除徵狀嗎？',
      buttons: [
        {
          text: '取消',
          role: 'cancel'
        },
        {
          text: '確認',
          handler: () => {
            // remove chosen selection
            this.consultationData.chosenSymptoms.splice(inIdx, 1);
            this.consultationData.chosenSymptomsRemark.splice(inIdx, 1);
          }
        }
      ],
      enableBackdropDismiss: false
    });
    symptomRemoveConfirm.present();

  }


  onAllClearClicked() {

    // prompt for confirmation
    let allClearConfirm = this.alertCtrl.create({
      title: '刪除',
      subTitle: '確認要刪除全部已選徵狀嗎？',
      buttons: [
        {
          text: '取消',
          role: 'cancel'
        },
        {
          text: '確認',
          handler: () => {

            // clear all selection
            this.consultationData.clearAllChosenSymptoms();

          }
        }
      ],
      enableBackdropDismiss: false
    });
    allClearConfirm.present();

  }


  // onSignClicked( inEvent )
  // {
  //
  //    // show conflicts dropdown
  //    let popover = this.popoverCtrl.create( PopoverSignPage, { 'value' : this.constants.accountInfo[ 'phy_name_zh' ], 'callback' : this.signPopoverHandler }, { cssClass: 'sign-popover' } );
  //    popover.present({
  //       ev: inEvent
  //    });
  //
  // }
  //
  //
  // signPopoverHandler = () => {
  //
  //    return new Promise( resolve => {
  //
  //       // this.consultationData.isConSigned = true;
  //       resolve();
  //    });
  // }
  //

  onNextClicked() {
    if (this.consultationData.dxIdx == -1) {
      // prompt for confirmation
      let dxEmptyConfirm = this.alertCtrl.create({
        title: '未有診斷資料',
        subTitle: '請輸入診斷資料',
        buttons: [
          {
            text: '確認',
            role: 'cancel'
          }
        ],
        enableBackdropDismiss: false
      });
      dxEmptyConfirm.present();
    }
    else {
      this.navCtrl.push(DispensaryPage);
    }
  }

  onAcuButtoClick(mode){
      let param = {
        'token': this.data.token,
        'tkt_id': this.data.selectedTicket['tkt_id'],
        'is_start_acu': mode
      }
      // prompt for confirmation
      let onStastAcuConfirm = this.alertCtrl.create({
        title: mode == 1 ? '開始針灸' : '完成針灸',
        subTitle: mode == 1 ? '是否確認開始針灸?' : '是否確認完成針灸?',
        buttons: [
          {
            text: '取消',
            role: 'cancel'
          },
          {
            text: '確認',
            handler: () => {
              let loading = this.modalCtrl.create(LoadingPage, {}, { enableBackdropDismiss: false });
              loading.present();
              // clear all selection
              this.cloudData.acuButtonClicked(param)
                .then(res => {
                  if(res['status'])
                      this.data.selectedTicket = res['result']['ticket'];
                  loading.dismiss();
                })
                .catch(err => {
                  loading.dismiss();
                });
            }
          }
        ],
        enableBackdropDismiss: false
      });
      onStastAcuConfirm.present();
    }

    ionViewDidLeave(){
      if(this.dragService.find('consultation-bag') != null){
         this.dragService.destroy('consultation-bag');
      }
      this.subs.unsubscribe();
     }
}



// WEBPACK FOOTER //
// ./src/pages/consultation/consultation.ts